import { render, staticRenderFns } from "./chemistry.vue?vue&type=template&id=a92297e6&"
import script from "./chemistry.vue?vue&type=script&lang=js&"
export * from "./chemistry.vue?vue&type=script&lang=js&"
import style0 from "./chemistry.vue?vue&type=style&index=0&id=a92297e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports